// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hz9H","rootMobile":"styles_rootMobile__1o611"};